import { Reveal, Eyebrow } from "../Reveal";
import { PROCESS_STEPS } from "../../lib/site";

export const Process = () => (
  <section id="process" data-testid="process-section" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-12 scroll-mt-20">
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-2xl space-y-4 mb-12 lg:mb-16">
        <Eyebrow>How We Work</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
          A Proven 4-Step System. <span className="gradient-accent-text">No Guesswork.</span>
        </h2>
      </Reveal>
      <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="hidden lg:block absolute top-9 left-[12%] right-[12%] border-t border-dashed border-blue-500/30" />
        {PROCESS_STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.12}>
            <div data-testid={`process-step-${i}`} className="relative group">
              <div className="relative z-10 w-[72px] h-[72px] rounded-2xl glass-card flex items-center justify-center mb-5 group-hover:border-cyan-400/40 transition-colors duration-300">
                <span className="font-mono2 text-xl font-bold gradient-accent-text">{step.num}</span>
              </div>
              <h3 className="font-display text-lg sm:text-xl font-semibold text-white tracking-tight">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">{step.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
